var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_vm._v("\n    很抱歉 404 没有找到相关页面~\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }